import { buildApInvoiceFormState, buildPaymentDataState } from "./resource";
import { ApInvoiceStoreState } from "./types";

export const state: ApInvoiceStoreState = {
  formState: buildApInvoiceFormState(),
  prepaymentData: buildPaymentDataState(),
  inclusiveTaxRate: 0,
  taxBaseVariable: 1
};
